import NotificationManagementIndex from "../../pages/dashboard/notification-management/NotificationManagementIndex";
import NotificationCampaignView from "../../pages/dashboard/notification-management/NotificationCampaignView";
import CreateNotificationIndex from "../../pages/dashboard/notification-management/create/CreateNotificationIndex";
import { ALL_ROUTES } from "../AllRoutes";

export const notification_management_routes_group = [
  {
    path: ALL_ROUTES?.DASHBOARD_NOTIFICATION_MANAGEMENT,
    element: NotificationManagementIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_NOTIFICATION_MANAGEMENT_CREATE,
    element: CreateNotificationIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_NOTIFICATION_MANAGEMENT_VIEW,
    element: NotificationCampaignView,
  },
];
